<template>
  <div class="gallery">
    <div class="container">

      <div class="row justify-content-center mb-3">
        <div class="col-md-10 col-lg-8 col-xl-6">
          <iframe width="100%" height="315" src="https://www.youtube.com/embed/96tQFuFm4VA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class=""
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.items.length - 1"
          :key="index"
          :class="images.className"
        >
          <div class="d-flex flex-wrap row justify-content-center">
            <div
              class=""
              v-for="(image, imageIndex) in images.items"
              :key="imageIndex"
              :class="image.class"
            >
              <div
                class="elevation"
                :data-aos="image.transition"
                :data-aos-delay="imageIndex * 35"
              >
                <div class="gallery-item" @click="showPopup(image)">
                  <!-- <v-lazy-image :src=""/> -->
                  <img :src="`${image.th || image.full}?tr=w-450`" />
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="control left" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="control right" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <img :src="preview.full" class="img-fluid" />
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by
              <a :href="preview.copyright.link || null">{{ preview.copyright.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      slickOpt: {
        slideToShow: 1,
      },
      gallery: [
        {
          className: "col-12",
          items: [
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7893_VebSryAHKt.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7964_lkpgmprmun.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_5770dCTK_QACR0pON2C.jpg",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-1 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7781_g6h4onjwXe.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-2"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7439_5fAHHygpm8.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-2"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_8043CTK_0xLYVKIBp2u.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7877_P9eT8_tado.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7605_e0PdU0Rye.jpg",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-1 order-md-2"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7688CTK_Ioj-GZ4M2ln.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7680_i5fhb0pXzLZ.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP2_7309d_8ATY4x84v7.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-1"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP2_7170dCTK_howF3QLWDA.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-1"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP2_7332d_q1KlojgEE8E.jpg",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-1 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7544__xcvkduBPh.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-5"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7662_Zol7P1NHB.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_5669d_blJoKweWuV.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-1"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7887_hJEk6a4FQb.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-6"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7906_asJdEWqrE.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-6"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_8066CTK_R75LP1_uO.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-6"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7469_0Ys66fWW7bc.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-5"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7731_lJ24ku7oRZ.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-5"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_5598d_7yf46vAZcz.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-2"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP2_7204d_MHTJh9iLrtG.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-2"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_5631d_EDHMoRHXcdJ.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-2"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7547_s2xLCMyd3e.jpg",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-1 order-md-12"
            },
          ],
        },
      ],
      preview: null,
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    },
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach((items) => {
        images.push(...items.items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map((item) => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
  },
  watch: {
    preview() {
      if (this.preview === null) {
        document.querySelector("body").style.overflowY = null;
      } else {
        document.querySelector("body").style.overflowY = "hidden";
      }
    },
  },
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
